import Client from './client';

export default {
  find: id => Client.get(`/templates/${id}`),
  update: (data) => Client.put(`/templates/${data.id}`, data),
  preview: (path) => Client.get(path),
  previewGuest: (id, placeholder) => Client.get(`/guest/templates/${id}/preview?placeholder=${placeholder}`),
}
